// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DialogV5 = require("../../../v5/common/Components/DialogV5.bs.js");
let Intercom = require("../Intercom.bs.js");
let ButtonsV5 = require("../../../v5/common/Components/ButtonsV5.bs.js");
let EventLogs = require("../../EventLogs.bs.js");
let ViewStack = require("../ViewStack.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let UserSession = require("../UserSession/UserSession.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function body(chapter) {
  return `Top Agent Network's ` + chapter + ` chapter has been put on hold as we focus our resources on our more active chapters across the country.
      We appreciate your membership and will relaunch in $chapter when demand increases.`;
}

function ClosedChapterOverlay$LoggedInDialog(props) {
  let logout = props.logout;
  let match = Intercom.useIntercom();
  let show = match.show;
  return JsxRuntime.jsxs(DialogV5.make, {
    title: "Your chapter has been put on hold",
    isOpen: true,
    ariaLabel: "Your chapter has been put on hold",
    onDismiss: prim => {},
    showCloseButton: false,
    children: [
      JsxRuntime.jsx("div", {
        children: body(props.chapter),
        className: "leading-normal"
      }),
      JsxRuntime.jsx("div", {
        className: "mt-[16px]"
      }),
      JsxRuntime.jsxs(ViewStack.make, {
        justifyContent: "flexEnd",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => show(),
            children: "Contact support"
          }),
          JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            onClick: param => logout(),
            children: "Log out"
          })
        ]
      })
    ]
  });
}

let LoggedInDialog = {
  make: ClosedChapterOverlay$LoggedInDialog
};

let closedChapters = [
  "101",
  "102"
];

function ClosedChapterOverlay(props) {
  let chapter = UserSession.useChapterInfoOpt();
  let recordEvent = EventLogs.useRecordEventByCurrentUser();
  let logout = () => {
    recordEvent(undefined, "Logout", undefined);
    AuthSession.logout();
  };
  if (chapter === undefined) {
    return null;
  }
  let displayName = chapter.displayName;
  if (displayName !== undefined && closedChapters.includes(chapter.id)) {
    return JsxRuntime.jsx(ClosedChapterOverlay$LoggedInDialog, {
      logout: () => logout(),
      chapter: displayName
    });
  } else {
    return null;
  }
}

let make = ClosedChapterOverlay;

let $$default = ClosedChapterOverlay;

exports.body = body;
exports.LoggedInDialog = LoggedInDialog;
exports.closedChapters = closedChapters;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* DialogV5 Not a pure module */
